import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_LOADING = "saga/membership/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/membership/SET_PREV_PAGE_FILTERS";

export const FETCH_CURRENT_USER = "saga/membership/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/membership/FETCH_CURRENT_USER_SUCCESS";

export const UPDATE_ALL_DATA = "saga/membership/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/membership/UPDATE_ALL_DATA_SUCCESS";

export const FETCH_NEW_MEMBERSHIPS_SUCCESS = "saga/membership/FETCH_NEW_MEMBERSHIPS_SUCCESS";

export const FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS =
  "saga/membership/FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS";

export const FETCH_EXPIRED_MEMBERSHIPS_SUCCESS =
  "saga/membership/FETCH_EXPIRED_MEMBERSHIPS_SUCCESS";

export const FETCH_MEMBERSHIPS_SOLD_SUCCESS = "saga/membership/FETCH_MEMBERSHIPS_SOLD_SUCCESS";

export const FETCH_MEMBERS_AT_RISK_SUCCESS = "saga/membership/FETCH_MEMBERS_AT_RISK_SUCCESS";

export const FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS =
  "saga/membership/FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS";

export const FETCH_ZERO_VISITS_MEMBERS_SUCCESS =
  "saga/membership/FETCH_ZERO_VISITS_MEMBERS_SUCCESS";

export const FETCH_FROZEN_MEMBERS = "saga/membership/FETCH_FROZEN_MEMBERS";
export const FETCH_FROZEN_MEMBERS_SUCCESS = "saga/membership/FETCH_FROZEN_MEMBERS_SUCCESS";

export const FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE =
  "saga/membership/FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE";
export const FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS =
  "saga/membership/FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  let params = { short_url, organization_id, date: payload.date };

  let allSagas = [
    getNewMemberships(params),
    getNewMembershipsSoldData(params),
    getAtRiskMembersData(params),
    getTotalActiveMembersData(params),
    getZeroVisitsMembersData(params),
    getYearOverYearMembershipRevenue(params),
    getTotalFrozenMembers(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  let params = { short_url, organization_id, date: payload.date };

  let allSagas = [
    getNewMemberships(params),
    getNewMembershipsSoldData(params),
    getAtRiskMembersData(params),
    getTotalActiveMembersData(params),
    getZeroVisitsMembersData(params),
    getYearOverYearMembershipRevenue(params),
    getTotalFrozenMembers(params)
  ];

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getNewMemberships(params) {
  try {
    const newMembershipsResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership/new_memberships",
      { params }
    );
    yield put({ type: FETCH_NEW_MEMBERSHIPS_SUCCESS, payload: newMembershipsResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getNewMembershipsSoldData(params) {
  try {
    const newMembershipsSoldResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership/membership_sales",
      { params }
    );
    yield put({ type: FETCH_MEMBERSHIPS_SOLD_SUCCESS, payload: newMembershipsSoldResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getAtRiskMembersData(params) {
  try {
    const atRiskMembersResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership/members_at_risk",
      { params }
    );
    yield put({ type: FETCH_MEMBERS_AT_RISK_SUCCESS, payload: atRiskMembersResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getTotalActiveMembersData(params) {
  try {
    const totalActiveMembersResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership/total_active_members",
      { params }
    );
    yield put({
      type: FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS,
      payload: totalActiveMembersResponse.data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* getZeroVisitsMembersData(params) {
  try {
    const zeroVisitsMembersResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership/zero_visits_members",
      { params }
    );
    yield put({ type: FETCH_ZERO_VISITS_MEMBERS_SUCCESS, payload: zeroVisitsMembersResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getTotalFrozenMembers(params) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership/total_frozen_members",
      {
        params
      }
    );
    yield put({ type: FETCH_FROZEN_MEMBERS_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getYearOverYearMembershipRevenue(params) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership/year_over_year_membership_revenues",
      { params }
    );
    yield put({ type: FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}
